import styled from 'styled-components';

// The zero width keeps a long name out of the row's fit-content total; it needs a definite-width parent to grow into.
const TruncatedText = styled.div`
  flex: 1 1 0;
  width: 0;
  min-width: 0;
  max-width: max-content;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export default TruncatedText;
